<template>
  <v-dialog v-model="config.open" max-width="355" :persistent="persistent" >
    <v-card>
      <v-card-title class="headline">{{titulo}}</v-card-title>
      <v-form v-model="dObs" ref="formdObs">
        <v-layout row wrap>
          <v-flex xs12>
            <v-textarea v-model="config.obs" :rules="_rules" validate-on-blur></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout wrap p-b-10>
          <v-flex xs12 sm6>
            <v-btn @click="$emit('observacaoCancel')">{{labelBtnCancelar}}</v-btn>
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn color="info" @click="observacaoOk()" :loading="isLoading">{{labelBtnOk}}</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidacaoBase from "../plugins/js/ValidacaoBase";
export default {
  mixins: [ValidacaoBase],
  props: {//Propriedades que o objeto recebe como parametro
    rules:Array,
    persistent:Boolean,
    config: {
      type: Object,
      default: function() {
        return {
          open: false,
          titulo: "Observação",
          obs: null,
          labelBtnCancelar: "Cancelar",
          labelBtnOk: "Rejeitar"
        };
      }
    }
  },
  data() {//Declaracao de variaveis
    return {
      dObs: true,
      isLoading: false
    };
  },
  computed: {//Campos computados
    titulo: function() {
      return (this.config.titulo === this.config.titulo
        ? this.config.titulo
        : "Observação");
    },
    labelBtnCancelar: function() {
      return this.config.labelBtnCancelar ? this.config.labelBtnCancelar : "Cancelar";
    },
    labelBtnOk: function() {
      return this.config.labelBtnOk ? this.config.labelBtnOk : "Rejeitar";
    },
     _rules: function() {
      return this.rules ? this.rules : this.validacao.campoObrigatorio;
    },
  },
  watch: { //Propriedades assistidas
    "config.open": {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.isLoading = false;
        }
      }
    }
  },

  methods: {//Declaracao de todos os metodos
    observacaoOk() {
      if (this.$refs.formdObs.validate()) {
        this.isLoading = true;
        this.$emit("observacaoOk");
      }
    }
  }
};
</script>